function pyu_send_admin_request(arg_post_id) {

  // console.log('pyu_send_admin_request');
  console.log(my_translation);

  const user_id = jQuery("#pyu_select_user_" + arg_post_id).val();
  const cb_value = jQuery("#pyu_cb" + arg_post_id).prop('checked') ? 1 : 0;

  // console.log('Post ID: ' + arg_post_id);
  // console.log('User ID: ' + user_id);
  // console.log('Checkbox Value: ' + cb_value);

  var data = {
    'action': 'pyu-protect-files',
    'post_id': arg_post_id,
    'user_id': user_id,
    'protect': cb_value
  };

  jQuery.post(ajaxurl, data, function(response) {
    // console.log(response);

    if (response['protected']) {
      jQuery("#pyu_cb" + response['post_id']).prop('checked', true);
      jQuery('#pyu_status' + response['post_id']).text(' ' + my_translation.protected);
    }
    else {
      jQuery('#pyu_cb' + response['post_id']).prop('checked', false);
      jQuery('#pyu_status' + response['post_id']).text(' ' + my_translation.unprotected);
    }

    jQuery('#pyu_select_user_' + response['post_id'] + " option[value='" + response['username'] + "']").attr("selected", true);
    jQuery('#guid' + response['post_id']).attr("href", response['guid']);
    jQuery('#guid' + response['post_id']).text(response['guid']);

    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toast-top-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "500",
      "hideDuration": "500",
      "timeOut": "2500",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }
    toastr.success(my_translation.update_successfull);


  }).fail(function() {

    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toast-top-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "500",
      "hideDuration": "500",
      "timeOut": "2500",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }
    toastr.error(my_translation.update_error);

  });

}